/* global USE_SENTRY */
import React from 'react'
import { render } from 'react-dom'
import * as Sentry from '@sentry/react'

import makeStore, { history } from './store'
import './initIntegrations'

import App from './App'

import './ant.less'
import './index.css'


import { unregister } from './registerServiceWorker'
unregister()

let store

if (USE_SENTRY === 'true') {
  const sentryReduxEnhancer = Sentry.createReduxEnhancer()
  const storeConfig = {
    sentry: sentryReduxEnhancer,
  }
  store = makeStore(storeConfig)
} else {
  store = makeStore()
}

render(
  <App store={store} history={history} />,
  document.getElementById('root'),
)

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    render(
          <NextApp store={store} history={history} />,
          document.getElementById('root'),
    )
  })
}
